import env from "../env";

const PATH_INSCRIPCION = "/inscripcion";
const PATH_FORMULARIO = "/formulario";
const PATH_SISTEMA = "/app";
const PATH_INICIO = "/";
const PATH_ADMIN_LOGIN = "/auth/login";
const PATH_APP_PARTICIPANTE = "/app/participante";
const PROCESO = env("REACT_APP_NOMBRE_PROCESO") || "EXAMEN - ADMISIÓN";
const NOMBRE_SISTEMA = "Sistema de sorteo de participantes";

const ROUTE_APOYO = "personal-de-apoyo-administrativo";
const ROUTE_ESTUDIANTE = "estudiante";
const ROUTE_SUPERVISOR = "docente-supervisor";

const ROUTE_DOCENTE_ELABORADOR = "docente-elaborador";
const ROUTE_PERSONAL_ADMINISTRATIVO = "personal-apoyo-elaborador";
const ROUTE_TERCIO_ESTUDIANTIL = "tercio-estudiantil";

const PARTICIPANT_NAME_APOYO_SUPERVISION_COMPLETE_NAME_CAPITALIZED = "Administrativo de apoyo";
const PARTICIPANT_SUPERVISOR_SUPERVISION_COMPLETE_NAME_CAPITALIZED = "Supervisor de aula";
const PARTICIPANT_OBSERVADOR_SUPERVISION_COMPLETE_NAME_CAPITALIZED = "Estudiante";

const PARTICIPANT_ADMINISTRATIVO_INTERNAMIENTO_COMPLETE_NAME_CAPITALIZED = "Administrativo";
const PARTICIPANT_DOCENTE_ELABORADOR_INTERNAMIENTO_COMPLETE_NAME_CAPITALIZED = "Docente Elaborador";
const PARTICIPANT_TERCIO_ESTUDIANTIL_INTERNAMIENTO_COMPLETE_NAME_CAPITALIZED = "Tercio Estudiantil";

const TITLE_SISTEMA = "SISTEMA DE PARTICIPANTES";
const TITLE_SISTEMA_SHORT = "SIAD Participantes";

const ID_ESTUDIANTE = 1;
const ID_DOCENTE = 2;
const ID_ADMINISTRATIVO = 3;

const ID_INTERNAMIENTO = 1;
const ID_SUPERVISION = 2;

const ID_TIPO_PARTICIPACION_INTERNAMIENTO = 1;
const ID_TIPO_PARTICIPACION_SUPERVISION = 2;

const TIPO_DE_PARTICIPACION_INTERNAMIENTO_NOMBRE_COMPLETO_CAPITALIZED = "Internamiento";
const TIPO_DE_PARTICIPACION_SUPERVISION_NOMBRE_COMPLETO_CAPITALIZED = "Supervisión";

const DOCENTE_NAME_CAPITALIZED = "Docente";
const ADMINISTRATIVO_NAME_CAPITALIZED = "Administrativo";
const ESTUDIANTE_NAME_CAPITALIZED = "Estudiante";

const ID_TIPO_PARTICIPANTE_DOCENTE = 2;
const ID_TIPO_PARTICIPANTE_ADMINISTRATIVO = 3;
const ID_TIPO_PARTICIPANTE_ESTUDIANTE = 1;

const NO_INSCRITO = "No inscrito";
const PENDIENTE = "Pendiente";
const VALIDADO = "Validado";
const OBSERVADO = "Observado";
const SORTEADO = "Sorteado";

const ESTADO_NO_INSCRITO = "No inscrito";
const ESTADO_PENDIENTE = "Pendiente de revisión";
const ESTADO_VALIDADO = "Documentos validados";
const ESTADO_OBSERVADO = "Documentación observada";
const ESTADO_SORTEADO = "Ganador(a) del sorteo";

const ID_ESTADO_NO_INSCRITO = 1;
const ID_ESTADO_PENDIENTE = 2;
const ID_ESTADO_VALIDADO = 3;
const ID_ESTADO_OBSERVADO = 4;
const ID_ESTADO_SORTEADO = 5;

const USUARIO = {
  payload: {
    id: "123456781253",
    nombre: "Juan",
    apellido: "Perez",
    observacion: "",
    idestado: "1",
    estado: "pendiente",
    tipo_participante: "supervisor",
    idparticipante: "1"
  },
  success: true
};

const MODALIDADES = [
  {
    value: 1,
    name: "SUPERVISOR DE AULA",
    idtipoparticipante: ID_DOCENTE,
    idtipoparticipacion: ID_SUPERVISION
  },
  {
    value: 2,
    name: "ESTUDIANTE OBSERVADOR",
    idtipoparticipante: ID_ESTUDIANTE,
    idtipoparticipacion: ID_SUPERVISION
  },
  {
    value: 3,
    name: "ADMINISTRATIVO DE APOYO (SUPERVISIÓN)",
    idtipoparticipante: ID_ADMINISTRATIVO,
    idtipoparticipacion: ID_SUPERVISION
  },
  {
    value: 4,
    name: "ESTUDIANTE DE ING. SISTEMAS (REGISTRADOR)",
    idtipoparticipante: ID_ESTUDIANTE,
    idtipoparticipacion: ID_INTERNAMIENTO
  },
  {
    value: 5,
    name: "DOCENTE ELABORADOR",
    idtipoparticipante: ID_DOCENTE,
    idtipoparticipacion: ID_INTERNAMIENTO
  },
  {
    value: 6,
    name: "ADMINISTRATIVO INTERNAMIENTO (DIGITADOR, ELECTRICISTA, IMPRESIÓN)",
    idtipoparticipante: ID_ADMINISTRATIVO,
    idtipoparticipacion: ID_INTERNAMIENTO
  }

];

export {
  PATH_INSCRIPCION,
  PATH_SISTEMA,
  PATH_INICIO,
  PATH_ADMIN_LOGIN,
  USUARIO,
  PROCESO,
  PATH_FORMULARIO,
  ID_ESTUDIANTE,
  ID_DOCENTE,
  ID_ADMINISTRATIVO,
  NO_INSCRITO,
  PENDIENTE,
  VALIDADO,
  OBSERVADO,
  SORTEADO,
  ID_ESTADO_NO_INSCRITO,
  ID_ESTADO_PENDIENTE,
  ID_ESTADO_VALIDADO,
  ID_ESTADO_OBSERVADO,
  ID_ESTADO_SORTEADO,
  ROUTE_APOYO,
  ROUTE_ESTUDIANTE,
  ROUTE_SUPERVISOR,
  TITLE_SISTEMA,
  NOMBRE_SISTEMA,
  TITLE_SISTEMA_SHORT,
  PATH_APP_PARTICIPANTE,
  PARTICIPANT_NAME_APOYO_SUPERVISION_COMPLETE_NAME_CAPITALIZED,
  PARTICIPANT_SUPERVISOR_SUPERVISION_COMPLETE_NAME_CAPITALIZED,
  PARTICIPANT_OBSERVADOR_SUPERVISION_COMPLETE_NAME_CAPITALIZED,
  ESTADO_NO_INSCRITO,
  ESTADO_PENDIENTE,
  ESTADO_VALIDADO,
  ESTADO_OBSERVADO,
  ESTADO_SORTEADO,
  TIPO_DE_PARTICIPACION_INTERNAMIENTO_NOMBRE_COMPLETO_CAPITALIZED,
  TIPO_DE_PARTICIPACION_SUPERVISION_NOMBRE_COMPLETO_CAPITALIZED,
  PARTICIPANT_ADMINISTRATIVO_INTERNAMIENTO_COMPLETE_NAME_CAPITALIZED,
  PARTICIPANT_DOCENTE_ELABORADOR_INTERNAMIENTO_COMPLETE_NAME_CAPITALIZED,
  PARTICIPANT_TERCIO_ESTUDIANTIL_INTERNAMIENTO_COMPLETE_NAME_CAPITALIZED,
  ROUTE_DOCENTE_ELABORADOR,
  ROUTE_PERSONAL_ADMINISTRATIVO,
  ROUTE_TERCIO_ESTUDIANTIL,
  DOCENTE_NAME_CAPITALIZED,
  ADMINISTRATIVO_NAME_CAPITALIZED,
  ESTUDIANTE_NAME_CAPITALIZED,
  ID_TIPO_PARTICIPANTE_DOCENTE,
  ID_TIPO_PARTICIPANTE_ADMINISTRATIVO,
  ID_TIPO_PARTICIPANTE_ESTUDIANTE,
  ID_TIPO_PARTICIPACION_INTERNAMIENTO,
  ID_TIPO_PARTICIPACION_SUPERVISION,
  ID_INTERNAMIENTO,
  ID_SUPERVISION,
  MODALIDADES
};
